module.exports = __webpack_public_path__ + "images/fa-start-learning-m-mobile-bg.jpg";